module.exports = __webpack_public_path__ + "static/img/brand-first-3.0e3d5d62.png";